export default "__VITE_ASSET__c3980353__"